/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyResourceRecommendationSeverityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyResourceRecommendationSeverityQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyResourceRecommendationSeverityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyResourceRecommendationSeverityQueryOperator>): PolicyResourceRecommendationSeverityQueryOperator {
        let obj = Object.assign(new PolicyResourceRecommendationSeverityQueryOperator(), model);
        PolicyResourceRecommendationSeverityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyResourceRecommendationSeverityQueryOperator>): PolicyResourceRecommendationSeverityQueryOperator {
        if (!model) return null;
        return PolicyResourceRecommendationSeverityQueryOperator.newInstance(<PolicyResourceRecommendationSeverityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyResourceRecommendationSeverityQueryOperator) {
        if (!obj) return;

        models.PolicyResourceRecommendationSeverityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyResourceRecommendationSeverityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyResourceRecommendationSeverityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy resource recommendation severities to include
     */
    severities: Array<models.PolicySeverityRisk>;

}
